import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "panel" }
const _hoisted_2 = { class: "user-email" }
const _hoisted_3 = {
  key: 0,
  class: "list-wrap"
}
const _hoisted_4 = {
  key: 0,
  class: "msg"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "device-row-container" }
const _hoisted_7 = { class: "device-row" }
const _hoisted_8 = ["value", "onChange"]
const _hoisted_9 = { class: "device-info" }
const _hoisted_10 = { class: "device-name" }
const _hoisted_11 = {
  key: 0,
  class: "badge-archived"
}
const _hoisted_12 = {
  key: 0,
  class: "permissions-box"
}
const _hoisted_13 = { class: "perm-label" }
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = { class: "perm-label" }
const _hoisted_16 = ["onUpdate:modelValue"]
const _hoisted_17 = {
  key: 1,
  class: "loading"
}
const _hoisted_18 = {
  key: 2,
  class: "error"
}
const _hoisted_19 = ["disabled"]

import axios from "@/axiosInstance";
	import { onMounted, ref } from "vue";
	import { useToast } from "vue-toast-notification";

	
export default /*@__PURE__*/_defineComponent({
  __name: 'DeviceShareModal',
  props: {
    user: {}
  },
  emits: ["close", "saved"],
  setup(__props: any, { emit: __emit }) {

	const props = __props;

	const emit = __emit;
	const toast = useToast();

	const devices = ref<any[]>([]);
	const selectedDeviceIds = ref<number[]>([]);
	const permissionsMap = ref<Record<number, { can_edit_status: boolean; can_edit_thresholds: boolean }>>({});

	const loading = ref(false);
	const saving = ref(false);
	const error = ref<string | null>(null);

	/* ─── Caricamento dati ─── */
	onMounted(loadData);

	async function loadData() {
		if (!props.user?.id) return;

		loading.value = true;
		error.value = null;

		try {
			// 1. Carico TUTTI i device
			const { data: allDevices } = await axios.get("/devices/get-all-graphs", { withCredentials: true });
			devices.value = allDevices || [];

			// Initialize permissions map for all devices with defaults
			devices.value.forEach((d) => {
				if (!permissionsMap.value[d.id]) {
					permissionsMap.value[d.id] = { can_edit_status: false, can_edit_thresholds: false };
				}
			});

			// 2. Carico i device GIA' condivisi con questo utente
			const { data: shared } = await axios.get(`/auth/${props.user.id}/shared-devices`, { withCredentials: true });

			const sharedList = Array.isArray(shared) ? shared : shared?.devices || [];

			const ids: number[] = [];
			sharedList.forEach((item: any) => {
				const id = typeof item === "object" ? item.id : item;
				ids.push(id);

				// If we have permissions data, populate it
				if (typeof item === "object" && item.permissions) {
					permissionsMap.value[id] = {
						can_edit_status: !!item.permissions.can_edit_status,
						can_edit_thresholds: !!item.permissions.can_edit_thresholds,
					};
				}
			});
			selectedDeviceIds.value = ids;
		} catch (e: any) {
			console.error(e);
			error.value = e.response?.data?.details || "Errore durante il caricamento";
		} finally {
			loading.value = false;
		}
	}

	function ensurePermissionsInit(deviceId: number) {
		if (!permissionsMap.value[deviceId]) {
			permissionsMap.value[deviceId] = { can_edit_status: false, can_edit_thresholds: false };
		}
	}

	/* ─── Salvataggio ─── */
	async function saveChanges() {
		saving.value = true;
		try {
			// Construct the new payload format: { devices: [{ id, permissions: {...} }, ...] }
			const devicesPayload = selectedDeviceIds.value.map((id) => {
				return {
					id,
					permissions: permissionsMap.value[id] || { can_edit_status: false, can_edit_thresholds: false },
				};
			});

			await axios.post(
				`/auth/${props.user.id}/share-devices`,
				{
					devices: devicesPayload,
				},
				{ withCredentials: true }
			);

			toast.success("Condivisioni aggiornate con successo", {
				position: "top-right",
				duration: 2500,
			});
			emit("saved");
			emit("close");
		} catch (e: any) {
			toast.error(e.response?.data?.details || "Errore nel salvataggio", {
				position: "top-right",
				duration: 2500,
			});
		} finally {
			saving.value = false;
		}
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "mask",
    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("header", null, [
        _createElementVNode("h2", null, [
          _cache[4] || (_cache[4] = _createTextVNode(" Condividi device con ", -1)),
          _createElementVNode("span", _hoisted_2, _toDisplayString(__props.user?.email), 1)
        ]),
        _createElementVNode("button", {
          class: "x",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, " × ")
      ]),
      (!loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (!devices.value.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, " Nessun device disponibile. "))
              : (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(devices.value, (d) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: d.id
                    }, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("label", _hoisted_7, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            value: d.id,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedDeviceIds).value = $event)),
                            onChange: ($event: any) => (ensurePermissionsInit(d.id))
                          }, null, 40, _hoisted_8), [
                            [_vModelCheckbox, selectedDeviceIds.value]
                          ]),
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("strong", null, "#" + _toDisplayString(d.id), 1),
                            _createElementVNode("span", _hoisted_10, _toDisplayString(d.name || "— senza nome —"), 1),
                            (d.is_archived)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Archiviato"))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        (selectedDeviceIds.value.includes(d.id))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              _createElementVNode("label", _hoisted_13, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": ($event: any) => ((permissionsMap.value[d.id].can_edit_status) = $event)
                                }, null, 8, _hoisted_14), [
                                  [_vModelCheckbox, permissionsMap.value[d.id].can_edit_status]
                                ]),
                                _cache[5] || (_cache[5] = _createElementVNode("span", null, "Modifica Stato", -1))
                              ]),
                              _createElementVNode("label", _hoisted_15, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": ($event: any) => ((permissionsMap.value[d.id].can_edit_thresholds) = $event)
                                }, null, 8, _hoisted_16), [
                                  [_vModelCheckbox, permissionsMap.value[d.id].can_edit_thresholds]
                                ]),
                                _cache[6] || (_cache[6] = _createElementVNode("span", null, "Modifica Soglie", -1))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ]))
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_17, " Caricamento devices… ")),
      (error.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(error.value), 1))
        : _createCommentVNode("", true),
      _createElementVNode("footer", null, [
        _createElementVNode("button", {
          class: "btn-cancel",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
        }, " Annulla "),
        _createElementVNode("button", {
          class: "btn-save",
          disabled: saving.value || loading.value,
          onClick: saveChanges
        }, _toDisplayString(saving.value ? "Salvataggio..." : "Salva modifiche"), 9, _hoisted_19)
      ])
    ])
  ]))
}
}

})